import {ImageOpInputsOrNodes, ImageOpNode, ImageOpOutputs} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {Evaluator, registerNode} from "@cm/graph-v2-final"
import {definition} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/utils/lambda/definition"

@registerNode
export class ImageOpNodeLambda extends ImageOpNode<typeof definition> {
    static nodeClass = "ImageOpNodeLambda"
    static definition = definition

    constructor(parameters: ImageOpInputsOrNodes<typeof definition>) {
        super(parameters)
    }

    override run = async (evaluator: Evaluator<unknown>): Promise<ImageOpOutputs<typeof definition>> => {
        const parameters = await evaluator.getAll(this.parameters)
        return await parameters.fn(parameters.args)
    }
}
